// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
/* CSS Document */

.content-container {
  display: grid;
  grid-template-columns: 38% auto 330px;
  grid-template-rows: repeat(1, 1fr);
  gap: 10px; 
	height: calc(100vh - 80px);
}


.content-list-container {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(1, 1fr);
  gap: 10px; 
	height: calc(100vh - 80px);
}


.content-twocol-container {
  display: grid;
  grid-template-columns: auto 180px;
  grid-template-rows: repeat(1, 1fr);
  gap: 10px; 
	height: calc(100vh - 80px);
}

.content-three-container {
  display: grid;
  grid-template-columns: calc(50%) auto 250px;
  grid-template-rows: repeat(1, 1fr);
  gap: 10px; 
	height: calc(100vh - 80px);
}


.content-container-column {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(8, 1fr);
  gap: 10px; 
	height: calc(100vh - 80px);
}

.content-box {
  border-radius: 0px;
	background-color: #ffffff;
	overflow: hidden;
	scroll-behavior: auto;
	margin: 15px 0px 0px 15px;
	padding: 0px 15px 15px 0px;
	overflow-y: auto;
}

.content-button-box {
  border-radius: 0px;
	background-color: #ffffff;
	overflow: hidden;
	scroll-behavior: auto;
	padding-top: 15px;
	padding-left: 5px;
	
	margin-right: 10px;
	overflow-y: auto;
}


.content-comment-box {
  border-radius: 0px;
	background-color: #ffffff;
	overflow: hidden;
	scroll-behavior: auto;
	padding-top: 0px;
	padding-left: 5px;
	padding-right: 5px;
	overflow-y: auto;
	margin-right: 10px;
}





.border {
	border: thin #DBDBDB solid;
}


.blue-background {
  
      font-size: 24px;
	line-height: 1.4;
    padding: 10px;
    font-weight: 300;
    	color: #ffffff;
	background-color: #0028ff;
}


.content-box-main-textarea {
    position: relative;
    width: 100%;
      font-size: 18px;
	line-height: 1.4;
    font-weight: 300;
    border: 0px;
    height: 100%;
     box-sizing: border-box;
	padding-right: 5px;
	margin: 0px;
}

.content-box-main-textarea::placeholder {
 	color: #0028ff;
}

.content-box-main-headline {
    position: relative;
    width: 100%;
      font-size: 18px;
	line-height: 1.4;
    
    font-weight: 500;
    border: 0px;
    height: 100%;
     box-sizing: border-box;
 	padding-right: 15px;
	margin: 0px;
}

.content-box-main-headline::placeholder {
 	color: #0028ff;
}


.content-box-insert-textarea {
    position: relative;
    width: 100%;
      font-size: 18px;
	line-height: 1.4;
    
    font-weight: 300;
    height: 100%;
	border: 1px solid #0028ff;
     box-sizing: border-box;
  		margin: 0px;
	min-height: 0px;

}

.content-box-insert-textarea::placeholder {
 	color: #0028ff;
}


.three-one {
  grid-column: 3;
  grid-row: 1;
}



.two-one {
  grid-column: 2;
  grid-row: 1;
}

.two-grid {
  grid-column: 2;
}


.two-two {
  grid-column: 2;
  grid-row: 2;
}

.three-two {
  grid-column: 3;
  grid-row: 2;
}


.headline {
	width: 100%;
	height: 100%;
	border: solid 0px #ffffff;
	  font-size: 18px;
	line-height: 1.4;
	  
font-weight: 500;
	margin: 0px;
	padding: 5px;
}

.reviewed-changes {
		  font-size: 18px;
	line-height: 1.4;
	  
font-weight: 300;
}


.main-text {
	width: 100%;
	height: 100%;
	border: solid 0px #ffffff;
	  font-size: 18px;
	line-height: 1.4;
	  
font-weight: 300;
	margin: 0px;
	padding: 5px;
}

.inner-content-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(12, 1fr);
  gap: 10px; 
	height: calc(100vh - 120px);
	overflow: hidden;
}


.inner-content-container-flex {
	  grid-template-columns: repeat(5, 1fr);
  display: grid;
  gap: 10px; 
	height: calc(100vh - 120px);
	overflow: hidden;
}

.nine-rows {
  grid-template-rows: repeat(9, 1fr);
}

.ten-rows {
  grid-template-rows: repeat(10, 1fr);
}

.inner-content-box {
  border-radius: 0px;
	background-color: #ffffff;
	overflow: hidden;
	scroll-behavior: auto;
}

.inner-content-box-scroll {
  border-radius: 0px;
	background-color: #ffffff;
	overflow: hidden;
	scroll-behavior: auto;
	overflow-y: auto;
	padding-right: 5px;
}


.approval-selector {
	width: 250px;
}

.contentText {
	line-height: 1.6em;
	padding-right: 5px;
	font-size: 16px;
}

.overflow {
		overflow-y: auto;
}


.row-one {
  grid-row: span 1;
}

.col-one {
  grid-column: span 1;
}



.row-two {
  grid-row: span 2;
}


@media (min-width: 760px) {


.col-two {
  grid-column: span 2;
}
	
	}

@media (max-width: 760px) {


.grid-layout .col-two {
  grid-column: span 6;
}
	
	.grid-layout .col-one {
  grid-column: span 6;
}
	
	
	}

.row-three {
  grid-row: span 3;
}

.col-three {
  grid-column: span 3;
}

.row-four {
  grid-row: span 4;
}

.col-four {
  grid-column: span 4;
}

.row-five {
  grid-row: span 5;
}

.col-five {
  grid-column: span 5;
}

.row-six {
  grid-row: span 6;
}

.col-six {
  grid-column: span 6;
}

.row-seven {
  grid-row: span 7;
}

.col-seven {
  grid-column: span 7;
}

.row-eight {
  grid-row: span 8;
}

.col-eight {
  grid-column: span 8;
}

.row-nine {
  grid-row: span 9;
}

.col-nine {
  grid-column: span 9;
}


.row-ten {
  grid-row: span 10;
}

.col-ten {
  grid-column: span 10;
}

.row-eleven {
  grid-row: span 11;
}

.col-eleven {
  grid-column: span 11;
}

.row-twelve {
  grid-row: span 12;
}

.col-twelve {
  grid-column: span 12;
}


.middle {vertical-align: middle;}



.cookies-grid {
  display: grid;
  grid-template-columns: 5% calc(95% - 10px);
  gap: 10px; 
  margin: 0px;
	padding: 10px;
	background-color: #ffffff;
}



`, "",{"version":3,"sources":["webpack://./src/buzzbeat-styles.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,iBAAiB;;AAEjB;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;CACV,0BAA0B;AAC3B;;;AAGA;EACE,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,SAAS;CACV,0BAA0B;AAC3B;;;AAGA;EACE,aAAa;EACb,iCAAiC;EACjC,kCAAkC;EAClC,SAAS;CACV,0BAA0B;AAC3B;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,kCAAkC;EAClC,SAAS;CACV,0BAA0B;AAC3B;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;CACV,0BAA0B;AAC3B;;AAEA;EACE,kBAAkB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;EACE,kBAAkB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,iBAAiB;;CAEjB,kBAAkB;CAClB,gBAAgB;AACjB;;;AAGA;EACE,kBAAkB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;;;;;AAMA;CACC,0BAA0B;AAC3B;;;AAGA;;MAEM,eAAe;CACpB,gBAAgB;IACb,aAAa;IACb,gBAAgB;KACf,cAAc;CAClB,yBAAyB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,WAAW;MACT,eAAe;CACpB,gBAAgB;IACb,gBAAgB;IAChB,WAAW;IACX,YAAY;KACX,sBAAsB;CAC1B,kBAAkB;CAClB,WAAW;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;MACT,eAAe;CACpB,gBAAgB;;IAEb,gBAAgB;IAChB,WAAW;IACX,YAAY;KACX,sBAAsB;EACzB,mBAAmB;CACpB,WAAW;AACZ;;AAEA;EACE,cAAc;AAChB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;MACT,eAAe;CACpB,gBAAgB;;IAEb,gBAAgB;IAChB,YAAY;CACf,yBAAyB;KACrB,sBAAsB;IACvB,WAAW;CACd,eAAe;;AAEhB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,WAAW;AACb;;;;AAIA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;GACvB,eAAe;CACjB,gBAAgB;;AAEjB,gBAAgB;CACf,WAAW;CACX,YAAY;AACb;;AAEA;IACI,eAAe;CAClB,gBAAgB;;AAEjB,gBAAgB;AAChB;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;GACvB,eAAe;CACjB,gBAAgB;;AAEjB,gBAAgB;CACf,WAAW;CACX,YAAY;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,SAAS;CACV,2BAA2B;CAC3B,gBAAgB;AACjB;;;AAGA;GACG,qCAAqC;EACtC,aAAa;EACb,SAAS;CACV,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;EACE,kBAAkB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;AACnB;;;AAGA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE,gBAAgB;AAClB;;;AAGA;;;AAGA;EACE,mBAAmB;AACrB;;CAEC;;AAED;;;AAGA;EACE,mBAAmB;AACrB;;CAEC;EACC,mBAAmB;AACrB;;;CAGC;;AAED;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA,SAAS,sBAAsB,CAAC;;;;AAIhC;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,WAAW;CACZ,aAAa;CACb,yBAAyB;AAC1B","sourcesContent":["@charset \"utf-8\";\n/* CSS Document */\n\n.content-container {\n  display: grid;\n  grid-template-columns: 38% auto 330px;\n  grid-template-rows: repeat(1, 1fr);\n  gap: 10px; \n\theight: calc(100vh - 80px);\n}\n\n\n.content-list-container {\n  display: grid;\n  grid-template-columns: auto;\n  grid-template-rows: repeat(1, 1fr);\n  gap: 10px; \n\theight: calc(100vh - 80px);\n}\n\n\n.content-twocol-container {\n  display: grid;\n  grid-template-columns: auto 180px;\n  grid-template-rows: repeat(1, 1fr);\n  gap: 10px; \n\theight: calc(100vh - 80px);\n}\n\n.content-three-container {\n  display: grid;\n  grid-template-columns: calc(50%) auto 250px;\n  grid-template-rows: repeat(1, 1fr);\n  gap: 10px; \n\theight: calc(100vh - 80px);\n}\n\n\n.content-container-column {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  grid-template-rows: repeat(8, 1fr);\n  gap: 10px; \n\theight: calc(100vh - 80px);\n}\n\n.content-box {\n  border-radius: 0px;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tscroll-behavior: auto;\n\tmargin: 15px 0px 0px 15px;\n\tpadding: 0px 15px 15px 0px;\n\toverflow-y: auto;\n}\n\n.content-button-box {\n  border-radius: 0px;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tscroll-behavior: auto;\n\tpadding-top: 15px;\n\tpadding-left: 5px;\n\t\n\tmargin-right: 10px;\n\toverflow-y: auto;\n}\n\n\n.content-comment-box {\n  border-radius: 0px;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tscroll-behavior: auto;\n\tpadding-top: 0px;\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n\toverflow-y: auto;\n\tmargin-right: 10px;\n}\n\n\n\n\n\n.border {\n\tborder: thin #DBDBDB solid;\n}\n\n\n.blue-background {\n  \n      font-size: 24px;\n\tline-height: 1.4;\n    padding: 10px;\n    font-weight: 300;\n    \tcolor: #ffffff;\n\tbackground-color: #0028ff;\n}\n\n\n.content-box-main-textarea {\n    position: relative;\n    width: 100%;\n      font-size: 18px;\n\tline-height: 1.4;\n    font-weight: 300;\n    border: 0px;\n    height: 100%;\n     box-sizing: border-box;\n\tpadding-right: 5px;\n\tmargin: 0px;\n}\n\n.content-box-main-textarea::placeholder {\n \tcolor: #0028ff;\n}\n\n.content-box-main-headline {\n    position: relative;\n    width: 100%;\n      font-size: 18px;\n\tline-height: 1.4;\n    \n    font-weight: 500;\n    border: 0px;\n    height: 100%;\n     box-sizing: border-box;\n \tpadding-right: 15px;\n\tmargin: 0px;\n}\n\n.content-box-main-headline::placeholder {\n \tcolor: #0028ff;\n}\n\n\n.content-box-insert-textarea {\n    position: relative;\n    width: 100%;\n      font-size: 18px;\n\tline-height: 1.4;\n    \n    font-weight: 300;\n    height: 100%;\n\tborder: 1px solid #0028ff;\n     box-sizing: border-box;\n  \t\tmargin: 0px;\n\tmin-height: 0px;\n\n}\n\n.content-box-insert-textarea::placeholder {\n \tcolor: #0028ff;\n}\n\n\n.three-one {\n  grid-column: 3;\n  grid-row: 1;\n}\n\n\n\n.two-one {\n  grid-column: 2;\n  grid-row: 1;\n}\n\n.two-grid {\n  grid-column: 2;\n}\n\n\n.two-two {\n  grid-column: 2;\n  grid-row: 2;\n}\n\n.three-two {\n  grid-column: 3;\n  grid-row: 2;\n}\n\n\n.headline {\n\twidth: 100%;\n\theight: 100%;\n\tborder: solid 0px #ffffff;\n\t  font-size: 18px;\n\tline-height: 1.4;\n\t  \nfont-weight: 500;\n\tmargin: 0px;\n\tpadding: 5px;\n}\n\n.reviewed-changes {\n\t\t  font-size: 18px;\n\tline-height: 1.4;\n\t  \nfont-weight: 300;\n}\n\n\n.main-text {\n\twidth: 100%;\n\theight: 100%;\n\tborder: solid 0px #ffffff;\n\t  font-size: 18px;\n\tline-height: 1.4;\n\t  \nfont-weight: 300;\n\tmargin: 0px;\n\tpadding: 5px;\n}\n\n.inner-content-container {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: repeat(12, 1fr);\n  gap: 10px; \n\theight: calc(100vh - 120px);\n\toverflow: hidden;\n}\n\n\n.inner-content-container-flex {\n\t  grid-template-columns: repeat(5, 1fr);\n  display: grid;\n  gap: 10px; \n\theight: calc(100vh - 120px);\n\toverflow: hidden;\n}\n\n.nine-rows {\n  grid-template-rows: repeat(9, 1fr);\n}\n\n.ten-rows {\n  grid-template-rows: repeat(10, 1fr);\n}\n\n.inner-content-box {\n  border-radius: 0px;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tscroll-behavior: auto;\n}\n\n.inner-content-box-scroll {\n  border-radius: 0px;\n\tbackground-color: #ffffff;\n\toverflow: hidden;\n\tscroll-behavior: auto;\n\toverflow-y: auto;\n\tpadding-right: 5px;\n}\n\n\n.approval-selector {\n\twidth: 250px;\n}\n\n.contentText {\n\tline-height: 1.6em;\n\tpadding-right: 5px;\n\tfont-size: 16px;\n}\n\n.overflow {\n\t\toverflow-y: auto;\n}\n\n\n.row-one {\n  grid-row: span 1;\n}\n\n.col-one {\n  grid-column: span 1;\n}\n\n\n\n.row-two {\n  grid-row: span 2;\n}\n\n\n@media (min-width: 760px) {\n\n\n.col-two {\n  grid-column: span 2;\n}\n\t\n\t}\n\n@media (max-width: 760px) {\n\n\n.grid-layout .col-two {\n  grid-column: span 6;\n}\n\t\n\t.grid-layout .col-one {\n  grid-column: span 6;\n}\n\t\n\t\n\t}\n\n.row-three {\n  grid-row: span 3;\n}\n\n.col-three {\n  grid-column: span 3;\n}\n\n.row-four {\n  grid-row: span 4;\n}\n\n.col-four {\n  grid-column: span 4;\n}\n\n.row-five {\n  grid-row: span 5;\n}\n\n.col-five {\n  grid-column: span 5;\n}\n\n.row-six {\n  grid-row: span 6;\n}\n\n.col-six {\n  grid-column: span 6;\n}\n\n.row-seven {\n  grid-row: span 7;\n}\n\n.col-seven {\n  grid-column: span 7;\n}\n\n.row-eight {\n  grid-row: span 8;\n}\n\n.col-eight {\n  grid-column: span 8;\n}\n\n.row-nine {\n  grid-row: span 9;\n}\n\n.col-nine {\n  grid-column: span 9;\n}\n\n\n.row-ten {\n  grid-row: span 10;\n}\n\n.col-ten {\n  grid-column: span 10;\n}\n\n.row-eleven {\n  grid-row: span 11;\n}\n\n.col-eleven {\n  grid-column: span 11;\n}\n\n.row-twelve {\n  grid-row: span 12;\n}\n\n.col-twelve {\n  grid-column: span 12;\n}\n\n\n.middle {vertical-align: middle;}\n\n\n\n.cookies-grid {\n  display: grid;\n  grid-template-columns: 5% calc(95% - 10px);\n  gap: 10px; \n  margin: 0px;\n\tpadding: 10px;\n\tbackground-color: #ffffff;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
